import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import Section from "../../components/section/section";
import participantWelcomeImage from "../../assets/participant/welcome-image-1.png";

const ContactParticipant = (): React.JSX.Element => {
  return (
    <Section>
      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={participantWelcomeImage}
            alt="Kontakt Onlinebewerbungscoaching"
            sx={{
              width: "100%",
              height: { xs: 280, md: "100%" },
              minHeight: { md: 460 },
              objectFit: "cover",
              borderRadius: 2,
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            elevation={0}
            sx={{
              height: "100%",
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
              <Stack spacing={3} sx={{ height: "100%" }}>
                <Box>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      backgroundColor: "rgba(1, 75, 84, 0.08)",
                      color: "secondary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <SupportAgentOutlinedIcon />
                  </Box>

                  <Typography variant="overline" color="text.secondary">
                    Ansprechpartner
                  </Typography>
                  <Typography variant="h5" sx={{ mt: 0.5, fontWeight: 700 }}>
                    Team Onlinebewerbungscoaching der WBS TRAINING
                  </Typography>
                </Box>

                <Typography variant="body1" color="text.secondary">
                  Wir unterstützen dich bei organisatorischen Fragen rund um
                  deine Termine und bei der Nutzung des Portals.
                </Typography>

                <Divider />

                <Stack spacing={2}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: 2,
                      backgroundColor: "grey.50",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <MailOutlineIcon color="secondary" />
                      <Typography variant="subtitle2" color="text.secondary">
                        E-Mail
                      </Typography>
                    </Stack>

                    <Link
                      href="mailto:bewerbungscoaching@wbstraining.de"
                      underline="hover"
                      color="inherit"
                      sx={{
                        fontSize: { xs: "1rem", md: "1.1rem" },
                        fontWeight: 700,
                        wordBreak: "break-word",
                      }}
                    >
                      bewerbungscoaching@wbstraining.de
                    </Link>
                  </Box>

                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: 2,
                      backgroundColor: "grey.50",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <CallOutlinedIcon color="secondary" />
                      <Typography variant="subtitle2" color="text.secondary">
                        Telefon
                      </Typography>
                    </Stack>

                    <Link
                      href="tel:03070193480"
                      underline="hover"
                      color="inherit"
                      sx={{
                        fontSize: { xs: "1rem", md: "1.1rem" },
                        fontWeight: 700,
                      }}
                    >
                      030-70193480
                    </Link>
                  </Box>
                </Stack>

                <Box
                  sx={{
                    mt: "auto",
                    p: 2.5,
                    borderLeft: "4px solid",
                    borderColor: "secondary.main",
                    backgroundColor: "rgba(242, 178, 53, 0.08)",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    Tipp: Bei Fragen zur Buchung von Einzelcoachings oder zur
                    Nutzung des Portals ist das Team direkt per E-Mail oder
                    telefonisch erreichbar.
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Section>
  );
};

export default ContactParticipant;
